

















import { Vue, Component } from "vue-property-decorator";

@Component
export default class ExternalFlow extends Vue {
  public $refs!: {
    formSubmit: HTMLButtonElement;
  };

  public externalForm = {
    method: "GET",
    url: "/",
    fields: {}
  };

  public configure(data) {
    this.externalForm = { ...data.approval_url };
    if (this.externalForm.method !== "GET") {
      return;
    }
    const url = this.externalForm.url;
    const searchStartIndex = url.indexOf("?");
    const search = url.substring(searchStartIndex + 1);
    this.externalForm.url = url.substring(0, searchStartIndex);
    this.externalForm.fields = this.$_.merge(
      {},
      this.externalForm.fields,
      JSON.parse(
        '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
        (key, value) => {
          return key === "" ? value : decodeURIComponent(value);
        }
      )
    );
  }

  public submit() {
    this.$refs.formSubmit.click();
  }

  public handleExternalFlow(responseData) {
    this.configure(responseData);
    this.$nextTick(() => this.submit());
  }
}
